export default "__VITE_ASSET__Dljt5grt__"